import React from "react";
import {Text} from "..";

import styles from './Image.module.css';

import cx from "classnames";

const Image = ( { alt, source, children, ...props } ) =>
{
    
    return (
        <div className={styles.root}>
            <img className={ cx( styles.border, styles.round, styles.root ) } alt={alt} src={source} {...props} ></img>
            {
                children ? <Text align="center" type="bodySm">{children}</Text> : <></>
            }
        </div>
    );
}

Image.defaultProps = {};

export default Image;